import { Component, OnDestroy, OnInit } from "@angular/core";

import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";

import { TipoDTO } from "app/main/apps/shared/interfaces/tipo.interface";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";
import { CatalogoService } from "app/main/apps/shared/services/rest/catalogo.service";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";

import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { locale as english } from "../i18n/en";
import { locale as spanish } from "../i18n/es";
import { DialogContratistaComponent } from "./components/dialog-contratista/dialog-contratista.component";
import { Filtro } from "../../../shared/interfaces/filtro.interface";
import { FiltroContratista } from "app/main/apps/shared/interfaces/filtro-contratista.interface";
import { FiltrosService } from "app/main/apps/shared/services/util/filtros.service";
import { config as CONFIG } from "app/app.config";

@Component({
    selector: "app-contratistas",
    templateUrl: "./contratistas.component.html",
    styleUrls: ["./contratistas.component.scss"],
    animations: fuseAnimations,
})
export class ContratistasComponent implements OnInit, OnDestroy {
    private subscripciones: Subscription;
    bancos: CodigoDTO[];
    tiposCuenta: TipoDTO[];
    contratistas: ContratistaDTO[];
    mostrarFiltros: boolean;
    comunas: CodigoDTO[];
    grupos: CategoriaDTO[];
    evaluaciones: Filtro[] = [];
    estados: Filtro[];
    filtros: FiltroContratista;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _notificacionSrvc: NotificacionesService,
        private _catalogoSrvc: CatalogoService,
        public _contratistaSrvc: ContratistaService,
        private _fuseProgressBarService: FuseProgressBarService,
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _dialogSrvc: DialogService,
        private _codigosSrvc: CodigosService,
        private _filtroSrvc: FiltrosService
    ) {
        this.mostrarFiltros = false;
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        this._filtroSrvc.getFiltro("filtrosContratista");
    }

    ngOnInit(): void {
        this.buscarContratistas();
        this.subscripciones.add(
            this._codigosSrvc
                .fetchBancos()
                .subscribe((resp) => (this.bancos = resp))
        );
        this.subscripciones.add(
            this._codigosSrvc
                .fetchTiposCuenta()
                .subscribe((resp) => (this.tiposCuenta = resp))
        );

        this.subscripciones.add(
            this._codigosSrvc
                .fetchComunas()
                .subscribe((resp) => (this.comunas = resp))
        );

        this.subscripciones.add(
            this._catalogoSrvc.fetchCatalogoServicios().subscribe((resp) => {
                this.grupos = this._catalogoSrvc.getTodosGrupos(resp);
            })
        );

        for (let index = 1; index <= CONFIG.rating.cantidadEstrellas; index++) {
            this.evaluaciones.push({
                valor: index,
                descripcion: `${index} estrella${index === 1 ? "" : "s"}`,
                tipo: null,
            });
        }

        this.estados = [
            {
                valor: true,
                descripcion: "Activos",
                tipo: null,
            },
        ];
    }

    buscarContratistas() {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._contratistaSrvc
                .fetchContratistas()
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => {
                    //console.log(resp);
                    this.contratistas = resp.content;
                    this._contratistaSrvc.contratistasChanged$.next(resp);
                    this._contratistaSrvc.setCantidadPaginas(resp.totalPages);
                    this._contratistaSrvc.setTotalDeResultados(
                        resp.totalElements
                    );
                    this._contratistaSrvc.setPaginaActual(
                        resp.pageable.pageNumber
                    );
                    this._contratistaSrvc.setCantidaResultadosPorPagina(
                        resp.size
                    );
                    //this._contratistaSrvc.setOrden(resp.sort.sorted);
                    //this._contratistaSrvc.contratistasRefresh$.next(true);
                })
        );
    }

    nuevoContratista(contratista: ContratistaDTO = null) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogContratistaComponent,
            "clase-dialog",
            "500px",
            {
                contratista,
                editar: false,
                bancos: this.bancos,
                tiposCuenta: this.tiposCuenta,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                //console.log("grbar");
                const {
                    rut,
                    nombres,
                    apellidos,
                    banco,
                    tipoCuenta,
                    nroCuenta,
                    correo
                } = result;
                const rutSeparado = rut.split("-");
                const contratista = new ContratistaDTO(
                    rutSeparado[0],
                    rutSeparado[1],
                    nombres,
                    apellidos,
                    banco,
                    tipoCuenta,
                    nroCuenta,
                    correo
                );
                this._contratistaSrvc
                    .actualizaContratista(contratista)
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Contratista ingresado correctamente",
                            "success"
                        );
                        this._contratistaSrvc.contratistasRefresh$.next(true);

                        this.buscarContratistas();
                    });
            }
        });
    }

    filtrar(event: FiltroContratista) {
        this._contratistaSrvc.resetPaginador();

        this._contratistaSrvc.contratistasRefresh$.next(true);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
